import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { getSubmitChartValidationArray, setSubmitChartState } from '../store/submitChart.actions'

export function* getSubmitChart(pcrDoc: IPcr) {
  const submitChart = pcrDoc.submitChart
  if (submitChart && Object.keys(submitChart).length !== 0) {
    yield put(setSubmitChartState(submitChart))
  }
  yield put(getSubmitChartValidationArray())
}
